import { createSlice } from "@reduxjs/toolkit";
import { StateMap } from "../../../../../lib/constant.ts";
import { fetchPhoneCandidatesList } from "../api.ts";
import { phoneCandidatesInitialState } from "../../constants.ts";

const initialState = phoneCandidatesInitialState;

export const phoneCandidatesSlice = createSlice({
  name: "phoneCandidates",
  initialState,
  reducers: {
    prevPage: (state) => {
      if (state.page > 1) state.page = state.page - 1;
    },
    nextPage: (state) => {
      if (state.metadata.next) state.page = state.page + 1;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSort: (state, action) => {
      state.sortBy = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPhoneCandidatesList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPhoneCandidatesList.fulfilled, (state, action) => {
        const { results, ...metadata } = action.payload.data;
        const status = action.payload.status;
        state.metadata = metadata ?? {};

        if (results || action?.payload?.data?.count > 0) {
          if (status == StateMap.All) {
            state.list.all = results;
          } else if (status == StateMap.Interviewed) state.list.completed = results;
          else if (status == StateMap.InviteSent) state.list.invited = results;
          else if (status == StateMap.Unqualified)
            state.list.unqualified = results;
          else if (status == StateMap.Others) state.list.misc = results;
          else if (status == StateMap.Rejected) state.list.rejected = results;
          else state.list.curated = results;
        }
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchPhoneCandidatesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export const { prevPage, nextPage, setPage, setSort } =
  phoneCandidatesSlice.actions;

export default phoneCandidatesSlice.reducer;
